module.exports = __webpack_public_path__ + "img/background_3.890f2cd7.jpg";